import { PropsWithChildren, createContext, useCallback, useContext, useEffect, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'

import { doFetch } from '../global'
import store from '../redux/store/store'
import { fetchRefreshToken } from '../utils/authservice'

const NetworkContext = createContext<any>(null)


export default function NetworkProvider(props: PropsWithChildren): JSX.Element {
  const dispatch = useDispatch()
  const authToken = useSelector((state: any) => state?.authSlice?.token)
  const refreshToken = useSelector((state: any) => state?.authSlice?.refreshToken)
  const navigate = useNavigate()

  const tokenRef = useRef(authToken)
  useEffect(() => {
    tokenRef.current = authToken
  }, [authToken])

  const query = useCallback(
    async (url: string, options: any) => {
      try {
        let res: any = await doFetch(url, options, tokenRef.current);

        if (res?.status !== 401) {
          return await res?.json();
        }

        await fetchRefreshToken(store); // refresh token if needed
        res = await doFetch(url, options, tokenRef.current);
        return await res?.json();
      } catch (err) {
        console.log(err);
      }
    },
    [refreshToken, navigate, dispatch]
  );

  return <NetworkContext.Provider {...props} value={query} />
}

export function useFetch() {
  return useContext(NetworkContext)
}